import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  brandLogo: {
    height: 'auto',
    maxHeight: '70px',
    maxWidth: '100%',
  },
});

export interface BrandLogoProps {
  name?: string; // for alt
  logoUrl: string;
}

export default class BrandLogo extends React.PureComponent<BrandLogoProps> {
  render() {
    const { logoUrl, name } = this.props;
    return <img src={logoUrl} className={css(styles.brandLogo)} alt={name} />;
  }
}
